import { render } from "./PaasSettingsForm.vue?vue&type=template&id=1f6f5021"
import script from "./PaasSettingsForm.vue?vue&type=script&lang=js"
export * from "./PaasSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__